import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { HolterConsultationFollowingSteps } from '../customComponents/HolterConsultationFollowingSteps';

export function HolterConsultRequestRead(): JSX.Element {
    return (
        <>
            <ReadForm />
            <HolterConsultationFollowingSteps />
        </>
    );
}
